/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { aiIntegrationsListSchedules } from "../funcs/aiIntegrationsListSchedules.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAIIntegrationSchedulesResult } from "../models/components/listaiintegrationschedulesresult.js";
import {
  ListAIIntegrationSchedulesRequest,
  ListAIIntegrationSchedulesSecurity,
} from "../models/operations/listaiintegrationschedules.js";
import { unwrapAsync } from "../types/fp.js";
export type AiIntegrationSchedulesQueryData = ListAIIntegrationSchedulesResult;

export function prefetchAiIntegrationSchedules(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListAIIntegrationSchedulesRequest,
  security?: ListAIIntegrationSchedulesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAiIntegrationSchedulesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAiIntegrationSchedulesQuery(
  client$: GramCore,
  request: ListAIIntegrationSchedulesRequest,
  security?: ListAIIntegrationSchedulesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AiIntegrationSchedulesQueryData>;
} {
  return {
    queryKey: queryKeyAiIntegrationSchedules({
      provider: request.provider,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
    }),
    queryFn: async function aiIntegrationSchedulesQueryFn(
      ctx,
    ): Promise<AiIntegrationSchedulesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(aiIntegrationsListSchedules(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAiIntegrationSchedules(
  parameters: {
    provider: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "aiIntegrations", "listSchedules", parameters];
}
